import ApiService from "./api.service";

const Customers = {
  create: async function (data) {
    let response = await ApiService.post("/customer", data, "Customer was created");
    return response.data;
  },
  get: async function (customer_id, data) {
    let response = await ApiService.put("/customer/" + customer_id, data, "Customer was updated");
    return response.data;
  },
  update: async function (customer_id, data) {
    let response = await ApiService.put("/customer/" + customer_id, data, "Customer was updated");
    return response.data;
  },
  delete: async function (customer_id) {
    await ApiService.delete("/customer/" + customer_id, {},"Customer was deleted");
    return true;
  },
  search: async function (search) {
    let query = (search) ? {
      q: search
    } : {};
    let response = await ApiService.get("/customers", query);
    return response.data.customers;
  },
};

export default Customers;